import type {
  CampaignTemplateCustomStyle,
  ClubCampaignPrefectureGroup,
} from "@components/CampaignTemplate";
import CampaignTemplate from "@components/CampaignTemplate";
import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import { isTypeProps, queryForSSP } from "@libs/apolloClient";
import { paths } from "@libs/paths";
import { Reds202203_RawShopsDocument as RawShopsDocument } from "./__generated__/queries";
import styles from "./index.module.css";
import type { Reds202203_RawShopsQueryResult as RawShopsQueryResult } from "./__generated__/queries";
import type { ApolloError } from "@apollo/client";
import type { GetServerSideProps, NextPage } from "next";

const isProduction = process.env.DEPLOY_ENV === "production";
const PREFECTURES: Array<ClubCampaignPrefectureGroup> = [
  {
    prefecture: "埼玉",
    shopUuids: isProduction
      ? [
          "oTrKJTjI5E8U",
          "WoWnhYqlFjuT",
          "bEpO3Mud7ihz",
          "LA1saSCuVz8f",
          "4I5wRb3Ixe0K",
        ]
      : [
          "UuidUuidUuid",
          "UuidUuidUuid",
          "UuidUuidUuid",
          "UuidUuidUuid",
          "UuidUuidUuid",
        ],
  },
];

type Reds202203PageProps = {
  data?: RawShopsQueryResult["data"];
  prefectures?: Array<ClubCampaignPrefectureGroup>;
  error?: ApolloError;
};

const Reds202203: NextPage<Reds202203PageProps> = ({ data, prefectures }) => {
  return (
    <CommonLayout hasFooter noModal>
      <CommonHead
        title={"浦和レッズをお店で応援！浦和レッズを観戦できるスポーツバー"}
        description={
          "明治安田J1リーグ、AFCチャンピオンズリーグの浦和レッズ戦を応援できる浦和、川口、越谷などのDAZN公式契約スポーツバーをご紹介。応援ドリンクも販売中。スポーツバー探し、予約はFanstaで。"
        }
        ogUrl={paths.campaignReds202203}
        ogImage={`${process.env.APP_HOST}/img/campaign/reds-202203/ogp.png`}
        canonicalUrl={paths.campaignReds202203}
      />
      <CampaignTemplate
        teamName="浦和レッズ"
        slug="reds-202203"
        teamIds={[4]}
        colorText="赤白黒"
        prefectures={prefectures}
        shopData={data?.rawShops}
        customStyle={styles as CampaignTemplateCustomStyle}
        sportGenreSlug={"soccer"}
        teamSlug={"reds"}
        specialEventAreaHidden
      />
    </CommonLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  // PREFECTURESに定義されたデータからUUIDを抽出する。
  const shopUuids = PREFECTURES.map((p) => p.shopUuids);
  const flattenShopUuids = ([] as Array<string>).concat(...shopUuids);

  // 該当する店舗を検索する。
  const pageProps = await queryForSSP({
    query: RawShopsDocument,
    variables: {
      uuids: flattenShopUuids,
    },
  });

  if (!isTypeProps(pageProps)) {
    return {
      props: {},
    };
  }

  return {
    props: {
      ...pageProps.props,
      prefectures: PREFECTURES,
    },
  };
};

export default Reds202203;
